export class ClassesTags {
    public static readonly Active = "active";
    public static readonly Loading = "loading";
    public static readonly Toggled = "toggled";
    public static readonly Invalid = "invalid";
    
    constructor() {  }
}